import styled from 'styled-components';
import {mobileMedia} from '../../../../../../../globalVariables/GlobalVariables';
import {summeryText} from '../../../../genericPieChart/GenericPieChart.css';
import zIndex from '../../../../../../../globalVariables/zIndex';
import {tokens} from '@tickchak/react-share/app';
import {dFlex, dFlexColumn, alignCenter, alignEnd, justifyCenter} from '../../../../../../../globalVariables/GlobalFlex';
import {wideCardsMedia} from '../../timetableSales.css';

export const card = styled.div<{$wide?: boolean}>`
  ${dFlex}
  ${alignCenter}
  direction: ltr;
  flex: ${p => p.$wide ? 1.45 : 1} 1 0;
  min-width: 0;
  min-height: 125px;
  box-sizing: border-box;
  background: var(--TA-color-bg-base);
  border: 1px solid var(--TA-color-border-subtle);
  border-radius: 20px;
  padding: ${p => p.$wide ? 'var(--space-lg)' : 'var(--space-lg) var(--space-xl)'};
  gap: var(--space-xl);
  ${wideCardsMedia}{
    flex: ${p => p.$wide ? '1 1 100%' : '1 1 calc(50% - 8px)'};
    order: ${p => p.$wide ? 1 : 0};
  }
  ${mobileMedia}{
    flex: 1 1 auto;
    width: 100%;
    order: 0;
  }
`;
export const cardText = styled.div<{$wide?: boolean}>`
  ${dFlexColumn}
  ${alignEnd}
  flex: 1;
  min-width: 0;
  align-self: stretch;
  justify-content: ${p => p.$wide ? 'center' : 'space-between'};
  gap: var(--space-lg);
`;
export const cardTitle = styled.div`
  align-self: stretch;
  font-size: ${tokens.typography.fontSize.headingModal};
  font-weight: ${tokens.typography.fontWeight.regular};
  line-height: 28.6px;
  text-align: ${p => p.theme.rtl ? 'right' : 'left'};
`;
export const cardChart = styled.div`
  ${dFlex}
  ${alignEnd}
  ${justifyCenter}
  position: relative;
  width: 150px;
  height: 78px;
  flex-shrink: 0;
  ${summeryText}{
    justify-content: flex-end;
    z-index: ${zIndex.baseRaised};
  }
`;
export const donutValue = styled.div`
  font-size: ${tokens.typography.fontSize.headingModal};
  font-weight: ${tokens.typography.fontWeight.bold};
  line-height: 28.6px;
  text-align: center;
`;
export const donutSub = styled.div`
  font-size: ${tokens.typography.fontSize.caption};
  font-weight: ${tokens.typography.fontWeight.regular};
  line-height: 16px;
  color: var(--TA-color-text-default);
  white-space: nowrap;
`;
